import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { TAB_SUBJECT_MAP, VENDORS_TABS_OPTIONS } from './constants'
import { useCallback, useEffect, useMemo, useState } from 'react'
import useRouter from '../../../hooks/useRouter'
import { VendorsList } from './VendorsList/VendorsList'
import { routes } from '../../../router'
import { MY_COMMUNITY_KEYS } from '../constants'
import { MyVendors } from './MyVendors/MyVendors'
import { useVendorsAbility } from './Providers'
import { ACTIONS, SUBJECTS } from './Abilities/constants'

export const VendorsPageWithTabs = () => {
  const { query, navigate } = useRouter()
  const ability = useVendorsAbility()

  const availableTabs = useMemo(
    () =>
      VENDORS_TABS_OPTIONS.filter((tab) =>
        ability.can(ACTIONS.VIEW, TAB_SUBJECT_MAP[tab.value])
      ),
    [ability]
  )

  const getEffectiveTab = useCallback(
    (requested: string) => {
      const isPermitted = availableTabs.some((t) => t.value === requested)
      return isPermitted ? requested : availableTabs[0]?.value
    },
    [availableTabs]
  )

  const [activeSubTab, setActiveSubTab] = useState(() =>
    getEffectiveTab(query?.type || VENDORS_TABS_OPTIONS[0].value)
  )

  const handleTabs = (e) => {
    setActiveSubTab(e)
    navigate(`${routes.myCommunity}/${MY_COMMUNITY_KEYS.vendors}/${e}`)
  }

  useEffect(() => {
    if (query?.type) {
      setActiveSubTab(getEffectiveTab(query.type))
    }
  }, [query?.type, availableTabs, getEffectiveTab])

  return (
    <div>
      {availableTabs.length > 1 && (
        <RadioGroup.Buttons
          options={availableTabs}
          defaultValue={activeSubTab}
          onChange={handleTabs}
          className="mt-0"
        />
      )}
      {activeSubTab === VENDORS_TABS_OPTIONS[0].value &&
        ability.can(ACTIONS.VIEW, SUBJECTS.MY_VENDORS) && <MyVendors />}
      {activeSubTab === VENDORS_TABS_OPTIONS[1].value &&
        ability.can(ACTIONS.VIEW, SUBJECTS.VENDORS_REPOSITORY) && (
          <VendorsList />
        )}
    </div>
  )
}
